import React from "react";
import ReactDOM from "react-dom/client";
import { Experimental_CssVarsProvider as CSSVarsProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// import App from "./App";
import App from "@beta/storefront/App";

import theme from "./themes";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Amplitude analytics script. Include only in production build, so as to not
// effect data while developing locally.
if (process.env.REACT_APP_INCLUDE_AMPLITUDE === "true") {
  const script = document.createElement("script");
  script.src = `https://cdn.eu.amplitude.com/script/${process.env.REACT_APP_AMPLITUDE_API_KEY}.js`;
  script.async = true;
  script.onload = () => {
    window.amplitude.add(window.sessionReplay.plugin({ sampleRate: 1 }));
    window.amplitude.init(process.env.REACT_APP_AMPLITUDE_API_KEY, {
      "fetchRemoteConfig": true,
      "serverZone": "EU",
      "autocapture": {
        "attribution": true,
        "fileDownloads": true,
        "formInteractions": true,
        "pageViews": true,
        "sessions": true,
        "elementInteractions": true,
        "networkTracking": true,
        "webVitals": true,
        "frustrationInteractions": true,
      },
    });
  };
  document.head.appendChild(script);
};

root.render(
  <CSSVarsProvider theme={theme}>
    <CssBaseline />
    <App />
  </CSSVarsProvider>
);
